export default __webpack_public_path__ + "static/media/sobs.566ea061.jpg";